/**
 * Persistencia en localStorage del filtro de partidas de cocina, **por rol** (selectedRoleId).
 */

const STORAGE_PREFIX = 'wewelcom_copilot_station_filter';
const SNAPSHOT_VERSION = 1;

function storageKey(roleId) {
	return `${STORAGE_PREFIX}_${String(roleId)}`;
}

export function defaultStationFilterSnapshot() {
	return {
		v: SNAPSHOT_VERSION,
		showAllProductOrdersInKitchen: true,
		selectedStations: [],
		excludedStations: [],
		onlyProductOrdersWithoutElaborationStation: false,
		showProductOrdersWithoutElaborationWhenExcludingOnly: true,
	};
}

/**
 * @param {string|number|null|undefined} roleId
 * @returns {object|null} snapshot válido o null
 */
export function loadCopilotStationFilterSnapshot(roleId) {
	if (roleId == null || roleId === '' || String(roleId) === '0') return null;
	try {
		const raw = localStorage.getItem(storageKey(roleId));
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed || typeof parsed !== 'object' || parsed.v !== SNAPSHOT_VERSION) return null;
		if (typeof parsed.showAllProductOrdersInKitchen !== 'boolean') return null;
		if (!Array.isArray(parsed.selectedStations) || !Array.isArray(parsed.excludedStations)) return null;
		return {
			v: SNAPSHOT_VERSION,
			showAllProductOrdersInKitchen: parsed.showAllProductOrdersInKitchen,
			selectedStations: [...parsed.selectedStations],
			excludedStations: [...parsed.excludedStations],
			onlyProductOrdersWithoutElaborationStation: Boolean(parsed.onlyProductOrdersWithoutElaborationStation),
			showProductOrdersWithoutElaborationWhenExcludingOnly:
				parsed.showProductOrdersWithoutElaborationWhenExcludingOnly !== false,
		};
	} catch {
		return null;
	}
}

/**
 * Si hay partidas en Ver/Ocultar o «Ver sin partidas», `showAll` no puede quedar en true:
 * en ProductOrderService eso haría saltar todo el filtrado por estación.
 */
export function normalizeShowAllProductOrdersWithStationFilters(copilotState) {
	if (!copilotState.showAllProductOrdersInKitchen) return;
	const ex = copilotState.excludedStations?.length ?? 0;
	const inc = copilotState.selectedStations?.length ?? 0;
	const only = Boolean(copilotState.onlyProductOrdersWithoutElaborationStation);
	const hideSinPartidaSolo =
		ex === 0 &&
		inc === 0 &&
		!only &&
		copilotState.showProductOrdersWithoutElaborationWhenExcludingOnly === false;
	if (ex > 0 || inc > 0 || only || hideSinPartidaSolo) {
		copilotState.showAllProductOrdersInKitchen = false;
	}
}

/** @param {object} copilotState — state del módulo namespaced copilot */
export function applyStationFilterSnapshotToCopilotState(copilotState, snapshot) {
	const s = snapshot || defaultStationFilterSnapshot();
	copilotState.showAllProductOrdersInKitchen = s.showAllProductOrdersInKitchen;
	copilotState.selectedStations = [...(s.selectedStations || [])];
	copilotState.excludedStations = [...(s.excludedStations || [])];
	copilotState.onlyProductOrdersWithoutElaborationStation = Boolean(s.onlyProductOrdersWithoutElaborationStation);
	copilotState.showProductOrdersWithoutElaborationWhenExcludingOnly =
		s.showProductOrdersWithoutElaborationWhenExcludingOnly !== false;
	normalizeShowAllProductOrdersWithStationFilters(copilotState);
}

/** @param {string|number|null|undefined} roleId @param {object} copilotState */
export function saveCopilotStationFilterSnapshot(roleId, copilotState) {
	if (roleId == null || roleId === '' || String(roleId) === '0') return;
	const snapshot = {
		v: SNAPSHOT_VERSION,
		showAllProductOrdersInKitchen: Boolean(copilotState.showAllProductOrdersInKitchen),
		selectedStations: [...(copilotState.selectedStations || [])],
		excludedStations: [...(copilotState.excludedStations || [])],
		onlyProductOrdersWithoutElaborationStation: Boolean(copilotState.onlyProductOrdersWithoutElaborationStation),
		showProductOrdersWithoutElaborationWhenExcludingOnly:
			copilotState.showProductOrdersWithoutElaborationWhenExcludingOnly !== false,
	};
	try {
		localStorage.setItem(storageKey(roleId), JSON.stringify(snapshot));
	} catch {
		// capacidad llena o modo privado
	}
}
